import { CustomTableConfig } from 'commons/components';
import { DEFAULT_LANGUAGE } from 'core/constants/constants';
import { useUserPreferencesContext } from 'core/contexts/user-preferences/hooks/use-user-preferences-context.hook';
import { useTranslation } from 'core/i18n/i18n';
import { formatDateTimeOrNow } from 'core/utils/dates';
import { useMemo } from 'react';
import { ActiveDirectoryListConnectionStatus } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/components/active-directory-connection-status';
import { ActiveDirectoryListItem } from '../active-directory-list-item.vm';

export const useDefaultConfigActiveDirectoryList = () => {
    const { t } = useTranslation();
    const { userLanguage = DEFAULT_LANGUAGE } = useUserPreferencesContext();

    const getHeaderColumn = (column: string) => `settings.integrations.active-directory.list.columns.${column}`;

    const defaultConfig = useMemo(
        (): CustomTableConfig<ActiveDirectoryListItem> => ({
            entity: 'activeDirectory',
            fields: [
                {
                    name: 'name',
                    headerOptions: {
                        text: t(getHeaderColumn('name')),
                        sortable: false,
                    },
                },
                {
                    name: 'status',
                    headerOptions: {
                        text: t(getHeaderColumn('status')),
                        sortable: false,
                    },
                    rowOptions: {
                        cellOptions: {
                            format: (item: ActiveDirectoryListItem) => (
                                <ActiveDirectoryListConnectionStatus
                                    status={item.status}
                                    lastAttempt={item.lastAttempt}
                                    errorMessage={item.errorConnectionDetail}
                                />
                            ),
                        },
                    },
                },
                {
                    name: 'existDataMapping',
                    headerOptions: {
                        text: t(getHeaderColumn('data-mapping')),
                        sortable: false,
                    },
                    rowOptions: {
                        cellOptions: {
                            format: (item: ActiveDirectoryListItem) =>
                                item.existDataMapping
                                    ? t('settings.integrations.active-directory.list.data-mapping-status.configured')
                                    : t('settings.integrations.active-directory.list.data-mapping-status.missing'),
                        },
                    },
                },
                {
                    name: 'lastSync',
                    headerOptions: {
                        text: t(getHeaderColumn('last-sync')),
                        sortable: false,
                    },
                    rowOptions: {
                        cellOptions: {
                            format: (item: ActiveDirectoryListItem) =>
                                item.lastSync
                                    ? formatDateTimeOrNow(item.lastSync, userLanguage, t('commons.utils.date.now'))
                                    : '-',
                        },
                    },
                },
            ],
        }),
        [t, userLanguage]
    );

    return { defaultConfig };
};
